export default {
      id: "Combined_Shape-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#Combined_Shape",
      toString: function () {
        return this.url;
      }
    }